import type {
  CookieConsentUiController,
  CookieConsentUiVisibility,
} from './types.ts'

import { type CookieConsentEngine } from '#src/assets/ui/mount/cookieConsentEngine.ts'

export const createCookieConsentController = ({
  visibility,
  rerender,
  engine,
  log,
}: {
  visibility: CookieConsentUiVisibility
  rerender: () => void
  engine: CookieConsentEngine
  log: (message: string, ...args: unknown[]) => void
}) => {
  const controller: CookieConsentUiController = {
    isBannerVisible: () => visibility.bannerVisible,
    isSettingsDialogVisible: () => visibility.settingsDialogVisible,
    isPreferencesModalVisible: () => visibility.preferencesModalVisible,
    showActionButton: () => {
      visibility.actionButtonVisible = true
      rerender()
    },
    hideActionButton: () => {
      visibility.actionButtonVisible = false
      rerender()
    },
    showBanner: () => {
      visibility.bannerVisible = true
      visibility.settingsDialogVisible = false
      visibility.preferencesModalVisible = false
      visibility.actionButtonVisible = false
      rerender()
    },
    hideBanner: () => {
      visibility.bannerVisible = false
      rerender()
    },
    showSettingsDialog: () => {
      visibility.bannerVisible = false
      visibility.settingsDialogVisible = true
      visibility.preferencesModalVisible = false
      visibility.actionButtonVisible = false
      rerender()
    },
    hideSettingsDialog: () => {
      visibility.settingsDialogVisible = false
      if (engine.hasValidConsent()) {
        visibility.actionButtonVisible = true
      } else {
        visibility.bannerVisible = true
      }
      rerender()
    },
    showPreferencesModal: () => {
      visibility.bannerVisible = false
      visibility.settingsDialogVisible = false
      visibility.preferencesModalVisible = true
      visibility.actionButtonVisible = false
      rerender()
    },
    hidePreferencesModal: () => {
      visibility.preferencesModalVisible = false
      if (engine.hasValidConsent()) {
        visibility.actionButtonVisible = true
      } else {
        visibility.bannerVisible = true
      }
      rerender()
    },
    showActionButtonIfConsent: () => {
      log('Showing action button after consent')
      if (
        !visibility.bannerVisible &&
        !visibility.settingsDialogVisible &&
        !visibility.preferencesModalVisible &&
        engine.hasValidConsent()
      ) {
        visibility.actionButtonVisible = true
        rerender()
      }
    },
    onConsentSaved: () => {
      visibility.bannerVisible = false
      visibility.settingsDialogVisible = false
      visibility.preferencesModalVisible = false
      controller.showActionButtonIfConsent()
    },
  }

  return controller
}
